import React from 'react';
import { motion } from 'framer-motion';
import { FootprintsIcon } from 'lucide-react';
export function HowItWorksSection() {
  return <section className="py-20 px-4 bg-white" data-id="element-132">
      <div className="max-w-4xl mx-auto text-center" data-id="element-133">
        <motion.div initial={{
        opacity: 0,
        scale: 0.9
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="mb-8 inline-block p-4 bg-cream-50 rounded-full" data-id="element-134">
          <FootprintsIcon className="w-10 h-10 text-terracotta-500" data-id="element-135" />
        </motion.div>

        <motion.h2 initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-3xl md:text-5xl font-serif text-brown-800 mb-8" data-id="element-136">
          La diferencia es el sistema: <br data-id="element-137" />
          <span className="text-terracotta-500" data-id="element-138">
            14 micro-decisiones guiadas.
          </span>
        </motion.h2>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.4
      }} className="text-xl text-stone-600 leading-relaxed max-w-2xl mx-auto" data-id="element-139">
          En vez de quedarte con "hazlo algún día", este plan te dice qué hacer
          cada día para llegar a "listo para publicar". No se trata de
          inspiración.{' '}
          <span className="font-bold text-brown-800" data-id="element-140">
            Se trata de terminar.
          </span>
        </motion.p>
      </div>
    </section>;
}